import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import orderBy from 'lodash/orderBy';
import get from 'lodash/get';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { withApollo, compose } from 'react-apollo';
import { v4 as uuidv4 } from 'uuid';
import TodoCard from 'chameleon/ui-stack/ui/units/todo-card';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import useGetClassIds from 'chameleon/ui-stack/hooks/use-get-classids';
import useLocalStorage from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import AssignmentOpen from 'legacy-src/utility/AssignmentOpen';
import * as types from 'legacy-src/constants/types';
import { MobileMedia } from 'legacy-src/utility/ResponsiveView';
import Carousel from 'legacy-src/utility/carousel/Index';
import CarouselPrevSkipButtons from 'chameleon/legacy/src/utility/carousel/CarouselPrevSkipButtons';
import CarouselNextSkipButtons from 'chameleon/legacy/src/utility/carousel/CarouselNextSkipButtons';
import log from 'chameleon/ui-stack/utilities/log';
import { getDomElSiblings } from 'chameleon/ui-stack/utilities/utils';
import { displayDigitalAssessmentInfoModal } from 'legacy/src/components/assessment/DigitalAssessmentInfoModal/utils';
import DigitalAssessmentInfoModal from 'legacy/src/components/assessment/DigitalAssessmentInfoModal';
import {
  TEACHER_AUTHORED,
  PPC,
  PE,
} from 'chameleon-src/components/assignments/constants';
import {
  getWelcomeVideo as getWelcomeVideoAction,
  getWelcomeVideoResponses as getWelcomeVideoResponsesAction,
} from 'legacy-packages/wizards/src/actions';
import InformationalModal from 'chameleon/ui-stack/ui/modals/informational-modal';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';
import { AutoAssignInfoModal } from 'chameleon/src/components/InfoModalAutoAssignedPC/utils';
import { AP_AFRICAN_AMERICAN_STUDIES } from 'chameleon/src/constants/subjects';
import { useFetchTodos, useGetWizardVideoTodos } from './hooks';
import {
  cleanReturnPath,
  getStudentCarrouselforProgram,
  getTodoCardType,
} from './helpers';
import {
  STATIC_CARD_HEADLINES,
  TODO_CARDS_CONFIG,
  TODO_CARD_TYPES,
  DEFAULT_EMPTY_STATIC_ITEMS,
} from './constants';
import TodoCardsSkeleton from './Skeleton';

class TodoCardsWrapper extends AssignmentOpen {
  render() {
    const { secureAssessmentOnMobile = false } = this.state || {};
    return (
      <Fragment>
        {this.renderModals()}
        <TodoCards
          {...this.props}
          secureAssessmentOnMobile={secureAssessmentOnMobile}
          beginAssignment={this.beginAssignment}
          onTimedAssessmentClick={this.onTimedAssessmentClick}
          secureAssessmentOnMobileModalProps={
            this.secureAssessmentOnMobileModalProps
          }
        />
      </Fragment>
    );
  }
}

const TodoCards = (props) => {
  const {
    client,
    params: { subject },
    userData,
    featureFlag,
    userPreferences,
    userSubjects,
    subjectData,
    isImpersonating,
    sharedResources,
    dispatch,
    router,
    onTimedAssessmentClick,
    beginAssignment,
    secureAssessmentOnMobile,
    secureAssessmentOnMobileModalProps,
  } = props;
  const {
    location: { pathname, search, state = {} },
  } = router;
  const { focusedElement } = state;
  const { isPreApSubject, hasFrqPracticeAssignments, subjectProgram } =
    subjectData;
  const {
    to_do_student_practice: showPeTodoCard,
    ap_live_to_do: apLiveTodoFlag,
    show_ap_stories_in_user_menu: welcomeVideoFlag,
    show_hide_welcome_to_ap_classroom: showHideWelcomeToApClassroom,
    bluebook_ui: bluebookUIFF,
  } = featureFlag;
  const { resources, isFetching: isFetchingSharedResources } = sharedResources;
  const {
    chosenEducationPeriodCode,
    me: { sections, initId: userId },
  } = userData;
  const [todos, setTodos] = useState([]);
  const [pinnedItems, setPinnedItems] = useState([]);
  const carouselRef = useRef();
  const elemWithTransitionRef = useRef();
  const assignmentClickedEventRef = useRef();
  const [carouselKey, setCarouselKey] = useState(0);
  const [slideIndexBackup, setSlideIndexBackup] = useState(0);
  const [displayDigitalAssessmentModal, setDisplayDigitalAssessmentModal] =
    useState(false);
  const digitalAssessmentModalCB = useRef();
  const navButtonsContainerRef = useRef();
  const focusedElementStorage = useRef(
    String(focusedElement || window.localStorage.getItem('todo-focus') || ''),
  );

  const redirectFocus = (cardIndex, ref) => {
    if (focusedElementStorage.current) {
      window.localStorage.removeItem('todo-focus');
      focusedElementStorage.current = '';
      const { goToSlide } = carouselRef?.current?.container?.carousel || {};
      const { slideCount } =
        carouselRef?.current?.container?.carousel?.state || {};
      const { maxCardsOnPage } = carouselRef?.current?.container?.state || {};

      if (ref.current.focus && typeof ref.current.focus === 'function') {
        if (cardIndex + maxCardsOnPage > slideCount) {
          const index = slideCount - maxCardsOnPage + 1;
          goToSlide(index);
        } else {
          goToSlide(cardIndex);
        }
        setTimeout(() => {
          ref.current.focus();
        });
      }
    }
  };

  const [classIds] = useGetClassIds({
    subjectId: subject,
    sections,
  });

  const isMobileResolution = useRef(false);
  const {
    todos: assignedTodos,
    loading,
    hasPeAssignments,
  } = useFetchTodos({
    dispatch,
    client,
    subjectId: subject,
    classIds,
    educationPeriod: chosenEducationPeriodCode,
    isImpersonating,
  });

  const [saveDismissedTodoCard, , getDismissedTodoCards] = useLocalStorage({
    key: 'dismissed-todo-cards',
    itemKey: `${subject}-${userId}`,
  });

  const { isLoading: isWizardVideoLoding, video } = useGetWizardVideoTodos();

  const hasClasses = classIds.length > 0;

  useEffect(() => {
    window.localStorage.removeItem('join_code_redirect');

    if (MobileMedia) {
      MobileMedia.addEventListener('change', onMediaQueriesChange);
    }

    if (MobileMedia.matches) {
      isMobileResolution.current = true;
    }
  }, []);

  useEffect(() => {
    if (subject) {
      //Init the localStorage for dismissed cards
      saveDismissedTodoCard(getDismissedTodoCards() || '');
    }
  }, [subject]);

  const onMediaQueriesChange = (event) => {
    isMobileResolution.current = event && event.matches;
  };

  const getPeExamAvailability = () =>
    showPeTodoCard &&
    !isPreApSubject &&
    hasPeAssignments &&
    hasFrqPracticeAssignments;

  /**
   * Provides welcome video, welcome video response and exam decision todos.
   *
   * @summary
   *   Display conditions:
   *     Carousel:
   *       1) When wizardVideo is_first_time is false and has_viewed is true, show watch video reminder.
   *       2) When wizardExam is_first_time is false, has_viewed is true and answers have 0 length, show feedback todo.
   *     Exam:
   *       1) When the current subject does not have a provided decision, display examOptIn or examOptOut todos.
   *       2) When selectedOption is EXAM_OPTIONS.NO, display decisionNo todo.
   *       3) When selectedOption is EXAM_OPTIONS.YES, display decisionYes todo.
   * @todo Exam condition 1 todo is set by subject name upon subject selector change. This should be done by ID instead.
   */
  const getStaticTodos = () => {
    const {
      ITEMS: { videoItems, youtubeItem, peCard },
    } = getStudentCarrouselforProgram(subjectProgram, subject); // eslint-disable-line
    const staticItems = cloneDeep(DEFAULT_EMPTY_STATIC_ITEMS);
    if (apLiveTodoFlag && youtubeItem) {
      const loc = isMobileResolution ? 'carousel' : 'pinned';
      staticItems[loc].push(youtubeItem);
    }

    const isPeExamAvailable = getPeExamAvailability();
    if (isPeExamAvailable && peCard) {
      staticItems.carousel.push(peCard);
    }

    /**
     * Welcome video todos.
     */
    if (welcomeVideoFlag && video && videoItems) {
      const isWelcomeVideoFirstTime = isImpersonating
        ? false
        : video.isFirstTime;
      if (!isWelcomeVideoFirstTime && !video.hasViewed) {
        /**
         * Carousel condition #1.
         */
        videoItems.watchVideo.date = video.createdAt;
        videoItems.watchVideo.timer = 2;
        staticItems.carousel.push(videoItems.watchVideo);
      } else if (
        !isWelcomeVideoFirstTime &&
        video.hasViewed &&
        !checkVideoResponses(video)
      ) {
        /**
         * Carousel condition #2.
         */
        videoItems.videoResponse.date = video.completedViewAt;
        staticItems.carousel.push(videoItems.videoResponse);
      }
    }
    return staticItems;
  };

  /**
   * Validates video question answers for completion.
   * @param {array} video Video data object with answers to evaluate.
   * @return {boolean}
   */
  const checkVideoResponses = (video) => {
    const responses =
      video.answers.length &&
      video.answers.filter((answer) => answer.length > 0);
    return responses && responses.length === video.questions.length;
  };

  const filterDismissedCards = (items) => {
    const dismissedTodoCards = getDismissedTodoCards() || '';
    const dismissedTodoCardsArray = dismissedTodoCards.split(',') || [];

    return items.filter(
      ({ id = '', headline }) =>
        !dismissedTodoCardsArray.includes(genTodoCardKey({ id, headline })),
    );
  };

  const renderDigitalAssessmentInfoModal = (e, callback) => {
    e.persist();
    assignmentClickedEventRef.current = e;
    setDisplayDigitalAssessmentModal(true);
    digitalAssessmentModalCB.current = callback;
  };

  const renderTodoItems = ({ items }) => {
    const returnPath = `${pathname}${search}`;
    /**
     * Prepend any static carousel todos with todos returned from todos/student endpoint.
     */

    const staticCardHeadlines = Object.values(STATIC_CARD_HEADLINES) || [];
    const HEADLINES_WITH_ACTIONS = ['WATCH', 'SHARE', 'SCORE'].concat(
      staticCardHeadlines,
    );
    const filteredItems = filterDismissedCards(items);
    return filteredItems.map((item, index) => {
      const {
        timer,
        id,
        headline,
        date,
        staticDate,
        message,
        subMessage,
        icon,
        isVideo,
        is_dismissible: isDismissible,
        is_practice_exam: isPracticeExam,
        is_ppc: isPPC,
        is_learning_checkpoint: isLC,
        is_performance_task: isPT,
        status,
        is_spp: isSPP,
      } = item;

      if (!HEADLINES_WITH_ACTIONS.includes(item.headline)) {
        item.onClick = beginAssignment;
      }
      if (timer && headline === 'BEGIN') {
        item.onClick = onTimedAssessmentClick;
      }
      const link =
        (headline !== 'VIEW RESULTS' && item.secure_link) || item.link || '';
      const splitLink = link.split('?');
      const linkPathname = splitLink[0];
      const linkSearch = splitLink.slice(1).join('?') || null;

      const isAssessment =
        headline === 'CONTINUE' ||
        headline === 'BEGIN' ||
        headline === 'SCORE' ||
        headline === 'FINISH' ||
        headline === 'VIEW RESULTS';

      const isQB = isAssessment && !isPPC;

      const cardType = getTodoCardType({
        isPracticeExam,
        isQB,
        isPPC,
        isLC,
        isPT,
        //isDailyVideo - dailyVideo
        isDailyVideo: isVideo,
        //other videos are welcome videos
        isWelcomeVideo:
          !isVideo &&
          [
            STATIC_CARD_HEADLINES.AP_LESSON,
            STATIC_CARD_HEADLINES.AP_WAIT_RESPONSE,
          ].includes(headline),
        isSPP,
      });

      let actionLabel;
      if (isVideo) {
        actionLabel = status === 'STARTED' ? 'CONTINUE' : 'WATCH';
      } else {
        actionLabel = headline;
      }

      const onClick = (e) => {
        const { clickable } = icon || {};
        const hasIcon = icon && typeof icon !== 'undefined';
        if (isVideo) {
          router.push({
            pathname: `/${linkPathname}`,
            search: `?${linkSearch}`,
            state: { fromToDoCard: true },
          });
        } else if (hasIcon) {
          if (isDismissible) {
            item.onClick(e);
          } else if (clickable) {
            router.push({
              pathname: `/${link}`,
              state: {
                returnPath,
              },
            });
          }
        } else if (!isVideo) {
          const { onClick } = item;

          if (isString(onClick) && isFunction(props[onClick || ''])) {
            e && e.preventDefault();
            /**
             * Invoke a function passed as a prop to this component.
             */
            props[onClick](props);
          } else if (
            isFunction(item.onClick) &&
            item.headline !== 'VIEW RESULTS'
          ) {
            e && e.preventDefault();
            /**
             * Invoke function in carousel item object.
             */
            item.onClick(item, cleanReturnPath(returnPath), item.id);
          } else if (link && /^(http|ldb1)/i.test(link)) {
            router.push({
              pathname: link,
              state: {
                focusedElement: item.id,
              },
            });
          } else if (link) {
            if (headline === 'SCORE') {
              router.push({
                pathname: `/${link}`,
                state: {
                  focusedElement: item.id,
                },
                search: `?returnPath=${cleanReturnPath(returnPath)}`,
              });
            } else {
              router.push({
                pathname: `/${link}`,
                state: {
                  returnPath,
                },
              });
            }
          }
        }
      };

      const card = TODO_CARDS_CONFIG.find(({ type }) => type === cardType);
      if (!card) {
        log(item);
      }
      const cardKey = genTodoCardKey({ id, headline });

      const getAssessmentType = () => {
        if (isPPC) return PPC;
        if (isPracticeExam) return PE;
        if (isQB) return TEACHER_AUTHORED;
        return '';
      };

      const shouldDisplayDigitalAssessmentInfoModal =
        displayDigitalAssessmentInfoModal({
          subject,
          bluebookUIFF,
          userPreferences,
          userSubjects,
          assesmentType: getAssessmentType(),
          subjectData,
          isStudent: true,
        }) && headline === 'BEGIN'; // Only show when student is about to start an assessment

      return (
        <TodoCard
          key={`todo-${cardKey}`}
          cardIndex={index}
          cardType={cardType}
          card={card}
          cardItem={item}
          date={staticDate || dayjs(date).format('MM/DD/YYYY')}
          message={message}
          subMessage={subMessage}
          timer={timer}
          actionLabel={actionLabel}
          onClick={
            shouldDisplayDigitalAssessmentInfoModal
              ? (e) => renderDigitalAssessmentInfoModal(e, onClick)
              : onClick
          }
          isWelcomeVideo={cardType === TODO_CARD_TYPES.WELCOME_VIDEO}
          onCloseClick={onCloseClick}
          onFadeOut={onTodoCardFadeOut}
          focusedElement={focusedElementStorage.current}
          carouselRef={carouselRef}
          redirectFocus={redirectFocus}
        />
      );
    });
  };

  const renderNoItemsMessage = (program) => (
    <div className="flex flex-col items-center mb-4.6">
      <h3 className="text-36 font-bold text-black text-center">
        Welcome to {program === types.AP ? types.AP : types.PreAP} Classroom
      </h3>
      <span className="w-4/5 page-subtitle font-light text-black opacity-75 text-center">
        Actions for you to take on your assignments will appear here (unless
        you've dismissed them) and under Assignments when your teacher assigns a
        resource. Right now, there are no actions to show.
      </span>
    </div>
  );

  const getSortedTodos = (_resources, _assignedTodos) => {
    const unsortedTodos = [..._resources, ..._assignedTodos];

    return orderBy(unsortedTodos, ['date']) || [];
  };

  const sortedTodos = useMemo(
    () => getSortedTodos(resources, assignedTodos),
    [resources, assignedTodos],
  );
  const [staticItems, setStaticItems] = useState(
    cloneDeep(DEFAULT_EMPTY_STATIC_ITEMS),
  );

  useEffect(() => {
    if (!isWizardVideoLoding) {
      setStaticItems(getStaticTodos());
    }
  }, [isWizardVideoLoding]);

  const getTodos = () => {
    if (!isFetchingSharedResources) {
      const items = renderTodoItems({
        items: staticItems.carousel.concat(sortedTodos),
      });
      setTodos(items);
    } else {
      setTodos([]);
    }
  };
  useEffect(getTodos, [staticItems.carousel, sortedTodos]);

  const getStaticItems = () => {
    const items = renderTodoItems({
      items: staticItems.pinned,
    });
    setPinnedItems(items);
  };
  useEffect(() => {
    if (staticItems.pinned.length > 0) {
      getStaticItems();
    }
  }, [staticItems.pinned]);

  const noItems = renderNoItemsMessage(subjectProgram);

  const PrevButtonWrapper = (props) =>
    createPortal(
      <ButtonWithIcon
        {...props}
        className="prev-item-arrow"
        accessibility={{
          'aria-label': 'Previous in to do cards',
        }}
        isPrimary
        isIcon
        icon="navigate_back"
        id="prev-todo-card-button"
      />,
      navButtonsContainerRef.current,
    );

  const NextButtonWrapper = (props) =>
    createPortal(
      <ButtonWithIcon
        {...props}
        accessibility={{
          'aria-label': 'Next in to do cards',
        }}
        isPrimary
        isIcon
        icon="navigate_next"
        id="next-todo-card-button"
      />,
      navButtonsContainerRef.current,
    );

  const SkipPrevButtonsWrapper = (props) =>
    createPortal(
      <CarouselPrevSkipButtons {...props} />,
      navButtonsContainerRef.current,
    );

  const SkipNextButtonsWrapper = (props) =>
    createPortal(
      <CarouselNextSkipButtons {...props} />,
      navButtonsContainerRef.current,
    );

  const settings = {
    slideIndex: slideIndexBackup,
    initialSlideHeight: 150,
    arrows: false,
    infinite: false,
    slidesToScroll: 1,
    prevButton: <PrevButtonWrapper />,
    nextButton: <NextButtonWrapper />,
    skipPrevButtons: <SkipPrevButtonsWrapper />,
    skipNextButtons: <SkipNextButtonsWrapper />,
  };

  const computeCards = () => {
    getTodos();
    getStaticItems();
  };

  const getResourceType = (cardItem) => {
    if (cardItem.is_practice_exam === true) {
      return 'PE';
    }
    if (cardItem.is_ppc === true) {
      return 'PC';
    }
    if (cardItem.is_spp === true) {
      return 'SPP';
    }
    if (
      cardItem.isVideo === true &&
      cardItem.displayName.includes('Daily Video')
    ) {
      return 'AP Daily Video';
    }
    if (cardItem.message === 'Welcome Video') {
      return 'Welcome Video';
    }
    if (cardItem.is_teacher_created === true) {
      return 'Teacher created quiz';
    }
    return '';
  };

  const sendTelemetry = (cardItem) => {
    const { id, isVideo, headline } = cardItem;
    const { importId: cbUserId, initId: amUserId } = window.current_user || {};
    let idString = '';
    if (id) {
      idString = id.toString();
    }
    const payload = {
      app: 'student_todo_cards',
      event_type: 'student_todo_card_dismiss',
      params: {},
      user: {
        am_user_id: amUserId,
        cb_user_id: cbUserId,
      },
      context: {
        subject_id: subject,
        id: idString,
        isVideo,
        headline,
      },
      resource_type: getResourceType(cardItem),
      resource_name: cardItem.message,
      timestamp: dayjs().utc().format(),
    };
    sendToTelemetry(Object.assign(payload, TLTRY_DEFAULTS[0]));
  };

  const onCloseClick = (event, cardItem) => {
    const { id = '', headline } = cardItem;
    const dismissedTodoCards = getDismissedTodoCards() || '';
    const cardKey = genTodoCardKey({ id, headline });
    saveDismissedTodoCard(dismissedTodoCards.concat(',').concat(cardKey));
    sendTelemetry(cardItem);

    const currentSlideIndex = get(
      carouselRef,
      'current.container.carousel.state.currentSlide',
    );
    const fitCards = get(carouselRef, 'current.container.props.fitCards');
    setSlideIndexBackup(
      currentSlideIndex > 0 && fitCards ? 0 : currentSlideIndex,
    );

    /**
     * After closing an item we want to check if there is empty space at the right of the carousel,
     * if there is then wait until the close animation finishes and simulate click on prev arrow so the carousel fixes itself.
     */
    const itemsLength = get(
      carouselRef,
      'current.container.props.items',
    ).length;
    const maxCardsOnPage = get(
      carouselRef,
      'current.container.state.maxCardsOnPage',
    );
    const maxSlideIndex = itemsLength - maxCardsOnPage;
    if (currentSlideIndex > maxSlideIndex) {
      window.setTimeout(() => {
        document.querySelector('.prev-item-arrow').click();
      }, 900);
    }

    /**
     * If it's the last card, because the fadeOut (sliding to left) is not required
     * so, we must recalculate the carousel items
     * */
    if (!event.target.closest('li').nextSibling) {
      computeCards();
      setCarouselKey(uuidv4());
    }
  };

  /**
   * Slides to the left all target siblings positioned on the right
   * */
  const slideToLeft = (width, siblings) => {
    siblings.forEach((elem) => {
      const left = `${parseInt(elem.style.left, 10) - width}px`;
      elem.style.transition = 'left 0.5s linear';
      elem.style.left = left;
    });
  };

  const realignCards = (target, carouselItem) => {
    const width = parseInt(carouselItem.style.width, 10);
    const carouselParentEl = target.closest('ul');
    carouselParentEl.style.height = '150px';
    const parentWidth = parseInt(carouselParentEl.style.width, 10) - width;
    carouselParentEl.style.width = `${parentWidth}px`;
    carouselItem.style.display = 'none';

    const siblings = getDomElSiblings(carouselItem);
    slideToLeft(width, siblings);
  };

  const onMovingCardsEnd = () => {
    /**
     * Allows the Carousel to recreate and correctly re-render the items
     * */
    setCarouselKey(uuidv4());
    computeCards();
  };

  const onTodoCardFadeOut = (target) => {
    if (elemWithTransitionRef.current) {
      elemWithTransitionRef.current.removeEventListener(
        'transitionend',
        onMovingCardsEnd,
      );
    }
    const carouselItem = target.closest('li');
    elemWithTransitionRef.current = carouselItem.nextSibling;
    if (elemWithTransitionRef.current) {
      elemWithTransitionRef.current.addEventListener(
        'transitionend',
        onMovingCardsEnd,
      );
      realignCards(target, carouselItem);
    }
  };

  // Check if the current student is part of a school_subject in the experiment.
  const currentSection = React.useMemo(
    () =>
      userData.me.sections.find(
        (section) => section.masterSubjectId === subject,
      ),
    [userData.me.sections, subject],
  );
  const [hasAutoAssignedPCs, setHasAutoAssignedPCs] = useState(false);
  useEffect(() => {
    if (!currentSection) return;
    if (currentSection.sectionType === 'EO') return;
    AutoAssignInfoModal.checkFlag(`${currentSection.parentId}_${subject}`).then(
      setHasAutoAssignedPCs,
    );
  }, [currentSection]);

  const genTodoCardKey = ({ id, headline }) =>
    `${id || ''}-${headline.replace(' ', '-')}`;

  // This is needed because the loading state is true when the user has no classes and the skeleton is never hidden
  if (!hasClasses) {
    return null;
  }

  if (loading || isWizardVideoLoding || isFetchingSharedResources) {
    return <TodoCardsSkeleton />;
  }

  const secureProps = secureAssessmentOnMobileModalProps();
  const isWelcomeShownBasedOnSubject = (subjectDataId) =>
    showHideWelcomeToApClassroom &&
    parseInt(subjectData.id) === subjectDataId &&
    todos.length === 0;

  return (
    <Fragment>
      {secureAssessmentOnMobile && (
        <InformationalModal {...omit(secureProps, ['content'])}>
          {secureProps.content}
        </InformationalModal>
      )}
      {displayDigitalAssessmentModal && (
        <DigitalAssessmentInfoModal
          onClose={() => setDisplayDigitalAssessmentModal(false)}
          onSubmit={() =>
            digitalAssessmentModalCB.current(assignmentClickedEventRef.current)
          }
        />
      )}
      {!isWelcomeShownBasedOnSubject(AP_AFRICAN_AMERICAN_STUDIES) && (
        <div className="bg-gray-100 relative shadow-toggleable-container">
          <div className="flex items-center pt-10 desktop:pl-7 desktop:pr-4 mobile:pl-9 desktop:justify-between">
            <div
              ref={navButtonsContainerRef}
              className="relative h-14 flex gap-11 gap-2 desktop:items-center mobile:mr-6"
            />
            <span className="mobile:mr-6">
              {todos.length > 0 || pinnedItems.length > 0 ? (
                <span className="self-center text-14 text-black">
                  If you dismiss a card, the assignment is still listed under
                  Assignments.
                </span>
              ) : null}
              {hasAutoAssignedPCs && (
                <span className="self-center text-14 bg-none">
                  <button
                    id="InfoModalAutoAssignedPC-Button"
                    className="bg-none cursor-pointer text-blue-500 underline"
                    onClick={AutoAssignInfoModal.trigger}
                  >
                    Learn about Progress Checks
                  </button>
                </span>
              )}
            </span>
            {!!todos.length && (
              <a
                className="sr-only focus-visible:left-5 focus-visible:w-fit focus-visible:h-fit focus-visible:relative font-medium"
                href="#mainHeading"
                onClick={() => document.querySelector('#mainHeading')?.focus()}
              >
                Skip to main content
              </a>
            )}
          </div>
          <Carousel
            key={carouselKey}
            ref={carouselRef}
            containerAttributes={{
              className: 'desktop:w-full mb-0.8',
            }}
            settings={settings}
            pinnedItems={pinnedItems}
            items={todos}
            noItems={noItems}
            itemHeading=""
            pinnedItemHeading=""
          />
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    featureFlag,
    impersonating: { isReadOnly: isImpersonating },
    sharedResources,
    userData: {
      me: { preferences },
    },
    userSubjects,
  } = state;

  return {
    featureFlag,
    isImpersonating,
    sharedResources,
    getWelcomeVideo: getWelcomeVideoAction,
    getWelcomeVideoResponses: getWelcomeVideoResponsesAction,
    userPreferences: preferences,
    userSubjects,
  };
};

export default compose(connect(mapStateToProps))(withApollo(TodoCardsWrapper));
